"use client";
import { cn } from "@/lib/utils";
import ProgramEnrollButton, {
  ProgramEnrollButtonProps,
} from "../ProgramEnrollButton";
import ProgramPricing from "@/components/ProgramDetailLayout/templates/components/ProgramPricing";
import { ProgramPricingData } from "@/lib/ecommerce/commercetools/client-only/getProgramPricingData";
import EmailOptIn from "@/components/EmailOptIn/EmailOptIn";
import useEmailOptIn from "@/components/ProgramDetailLayout/templates/context/ProgramDetailContext/hooks/useEmailOptIn";
import useTranslations from "@/i18n/useTranslations";

type ProgramMidPageCTA = ProgramEnrollButtonProps & {
  className?: string;
  duration: string;
  pricingData: ProgramPricingData | null;
  programIsEnrollable: boolean;
};

export default function MidPageCTABox(props: ProgramMidPageCTA) {
  const t = useTranslations("Course");
  const tCommon = useTranslations("Common");
  const { emailOptIn, setEmailOptIn } = useEmailOptIn();

  const {
    pricingData,
    programIsEnrollable,
    courses,
    duration,
    programData,
    skus,
  } = props || {};

  const title = programData?.title || "";
  const partners = programData?.partners || [];

  return (
    <div
      className={cn(
        "flex flex-col lg:flex-row justify-between text-center gap-6 py-6 px-4 sm:p-12 rounded-xl bg-primary-500",
        props.className,
      )}
    >
      <div className="flex flex-col gap-2 lg:gap-4">
        <h2 className="text-4xl font-black my-0 text-white italic text-center lg:text-left">
          {t("readyToAdvanceCareer")}
        </h2>
        <div className="[&_p]:m-0 flex justify-center lg:justify-start">
          <p className="text-xl md:text-2xl font-bold text-white">
            {tCommon("coursesInDuration", { count: courses.length, duration })}
          </p>
        </div>
        <div className="hidden md:block">
          <EmailOptIn
            title={title}
            partners={partners}
            optIn={emailOptIn}
            variant="secondary"
            toggleEmailOptIn={() => {
              setEmailOptIn(!emailOptIn);
            }}
            checkboxId="email-opt-in-program"
            labelClassName="text-white text-left text-xs"
          />
        </div>
      </div>
      <div className="self-center w-full sm:w-auto px-6 flex flex-col gap-4">
        {pricingData && (
          <div className="align-items-center justify-center flex gap-2 text-lg text-gray-800">
            <ProgramPricing
              pricingData={pricingData}
              strikethroughClass="line-through text-white opacity-50 font-bold"
              discountedPriceClassName="text-white font-bold"
            />
          </div>
        )}
        {programIsEnrollable &&
          programData.programEligibleForOneClickPurchase && (
            <ProgramEnrollButton
              courses={courses}
              programData={programData}
              skus={skus}
            />
          )}
        <div className="block md:hidden">
          <EmailOptIn
            title={title}
            partners={partners}
            optIn={emailOptIn}
            variant="secondary"
            toggleEmailOptIn={() => {
              setEmailOptIn(!emailOptIn);
            }}
            checkboxId="email-opt-in-program"
            labelClassName="text-white text-left text-xs"
          />
        </div>
      </div>
    </div>
  );
}
